// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_h7-0";
export var fulfillmentPanelBody = "_h7-1";